import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BlogHero from "./components/BlogHero";
import FeaturedPost from "./components/FeaturedPost";
import BlogGrid from "./components/BlogGrid";
import BlogCTA from "./components/BlogCTA";
import AnonymousThoughts from "./components/AnonymousThoughts";

export default function Blog() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <BlogHero />
        <FeaturedPost />
        <BlogGrid />
        <AnonymousThoughts />
        <BlogCTA />
      </main>
      <Footer />
    </div>
  );
}